import { render, staticRenderFns } from "./WithdrawalType.vue?vue&type=template&id=38c1d998&scoped=true"
import script from "./WithdrawalType.vue?vue&type=script&lang=js"
export * from "./WithdrawalType.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalType.vue?vue&type=style&index=0&id=38c1d998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c1d998",
  null
  
)

export default component.exports